import endpoints from './endpoints';
import request from './request';

const customerRuleApi = {
    list(companyId) {
        return request.get(
            endpoints.customer.rules.list(companyId),
        );
    },

    create(companyId, data) {
        return request.post(
            endpoints.customer.rules.create(companyId),
            data,
        );
    },

    update(companyId, ruleId, data) {
        return request.put(
            endpoints.customer.rules.update(
                companyId,
                ruleId,
            ),
            data,
        );
    },

    remove(companyId, ruleId) {
        return request.delete(
            endpoints.customer.rules.remove(
                companyId,
                ruleId,
            ),
        );
    },

    removeAll(companyId) {
        return request.delete(
            endpoints.customer.rules.removeAll(companyId),
        );
    },
};

export default customerRuleApi;


// WEBPACK FOOTER //
// ./src/api/customerRuleApi.js